exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bibleCloudBookSelector-menu[data-v-a0e9fae4] {\n  margin: 25px 25px 0 25px;\n}\n.bibleCloudBookSelector-section-title-disabled[data-v-a0e9fae4] {\n  opacity: 0.4;\n}\n.bibleCloudBookSelector-book[data-v-a0e9fae4] {\n  color: #111;\n  display: block;\n  margin: 8px 0;\n  padding: 0 11px;\n  text-decoration: none;\n}\n.bibleCloudBookSelector-book[data-v-a0e9fae4]:hover {\n  background: #eff1f6;\n}", ""]);

// exports
